<template>
  <div style="width: 100%; overflow-y: auto; overflow-x: hidden; height: 100%">
    <div style="padding: 20px; width: 100%; box-sizing: border-box">
      <el-button
        size="small"
        @click="back"
        icon="el-icon-arrow-left"
        class="back"
        >返回</el-button
      >
      <el-row
        class="mt2"
        type="flex"
        justify="center"
        style="background: #fff; padding: 35px 0 20px 0"
      >
        <el-col :span="8" style="position: relative;">
          <el-steps
            :active="active"
            process-status="success"
            :align-center="true"
          >
            <el-step title="待提交"></el-step>
            <el-step title="已提交"></el-step>
            <el-step title="订单已审核"></el-step>
            <el-step title="已配车"></el-step>
          </el-steps>
          <img v-if="form.extOrderId" style="position: absolute; top: -35px; right: -60px;" :src="customerOrder.isLocked ? locked : unlocked" width="80px" height="80px" alt="">
        </el-col>
      </el-row>
      <el-row class="mt1" type="flex" justify="space-between">
        <el-col :span="17">
          <el-form
            ref="form"
            :inline="true"
            label-position="right"
            :model="form"
            :rules="formRules"
            label-width="120px"
          >
            <el-row type="flex" justify="space-between" align="middle">
              <div class="title" style="width: 200px">
                车辆信息
                <span
                  @click="toCustomer"
                  style="color: #409eff"
                  v-if="formName != 'customerDetail'"
                  class="toCustomer"
                  >客户详情</span
                >
              </div>
              <el-form-item
                class="form_item"
                label-width="260px"
                v-if="form.extOrderId != ''"
                :label="'销售订单号:' + form.extOrderId"
              >
              </el-form-item>
              <div style="display: flex; height: 30px">
                <el-button size="mini" @click="through" v-if="allowOrderVerify"
                  >同意</el-button
                >
                <el-button
                  size="mini"
                  style="margin-left: 10px !important"
                  @click="reject"
                  v-if="allowOrderVerify"
                  >驳回
                </el-button>
                <!-- <el-button size="mini"
                           @click="orderWithdraw"
                           v-if="!type">订单撤回</el-button> -->
              </div>
            </el-row>
            <el-row style="background: #fff; padding: 15px 0">
              <!-- <el-form-item class="form_item"
                            label="合同编号"
                            prop="contractNo">
                <el-input size="mini"
                          disabled
                          style="width: 160px;"
                          placeholder="请输入"
                          v-model="form.contractNo"></el-input>
              </el-form-item> -->
              <el-form-item class="form_item" label="订单类型" prop="orderType">
                <el-select
                  size="mini"
                  style="width: 160px"
                  disabled
                  placeholder="请选择"
                  v-model="form.orderType"
                >
                  <el-option
                    v-for="item in orderTypeDics"
                    :key="item.dataValue"
                    :label="item.dataDisplay"
                    :value="item.dataValue"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="form_item" label="订购车型" prop="modelId">
                <el-cascader
                  size="mini"
                  class="filter-item"
                  disabled
                  style="width: 330px"
                  placeholder="选择订购车型"
                  filterable
                  :show-all-levels="true"
                  :options="carOptions"
                  v-model="form.modelId"
                  @change="changeSpecColor"
                ></el-cascader>
              </el-form-item>
              <el-form-item
                class="form_item"
                label="车辆状态"
                v-if="form.otdStatus != ''"
              >
                <div style="width: 160px">{{ form.otdStatus }}</div>
              </el-form-item>
              <el-form-item
                class="form_item"
                label="外观颜色"
                prop="modelColor"
              >
                <el-select
                  size="mini"
                  style="width: 160px"
                  placeholder="请选择"
                  disabled
                  v-model="form.modelColor"
                  @change="modelColorChange"
                >
                  <el-option
                    v-for="item in colors"
                    :key="item.color"
                    :label="item.color"
                    :value="item.color"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="form_item" label="内饰">
                <el-select
                  size="mini"
                  disabled
                  style="width: 160px"
                  placeholder="请选择"
                  v-model="form.carInternalColor"
                  @change="carInternalColorChange"
                >
                  <el-option
                    v-for="(item, index) in carInternalColor"
                    :key="index"
                    :label="item === '' ? '无' : item"
                    :value="item"
                  >
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item v-for="(options, key) in carModelOptionalsComputed" :key="key" class="form_item" :label="modelOptionalsKeyMap.get(key)">
                <el-select
                  size="mini"
                  disabled
                  style="width: 160px"
                  placeholder="请选择"
                  v-model="form.carModelOptionals[key]"
                >
                  <el-option
                    v-for="(item, index) in options"
                    :key="index"
                    :value="item === '无选装' ? '' : item"
                    :label="item === '' ? '无' : item"
                  >
                  </el-option>
                </el-select>
              </el-form-item>

              <!-- <el-form-item class="form_item"
                            label="车架号">
                <el-select size="mini"
                           style="width:160px;"
                           disabled
                           placeholder="请选择"
                           v-model="form.modelVin">
                  <el-option v-for="item in vins"
                             :key="item.vin"
                             :label="item.vin"
                             :value="item.vin"></el-option>
                </el-select>
              </el-form-item> -->
              <!-- <el-form-item class="form_item"
                            label="是否三包车"
                            prop="isSanbao">
                <el-select size="mini"
                           style="width:160px;"
                           disabled
                           placeholder="请选择"
                           v-model="form.isSanbao">
                  <el-option :value="true"
                             label="是"></el-option>
                  <el-option :value="false"
                             label="否"></el-option>
                </el-select>
              </el-form-item> -->
              <el-form-item class="form_item" label="订金" prop="paymentDown">
                <el-input
                  size="mini"
                  disabled
                  style="width: 160px"
                  placeholder="请输入"
                  v-model="form.paymentDown"
                >
                </el-input>
              </el-form-item>
              <el-form-item class="form_item" label="收款方式" prop="payType">
                <el-select
                  size="mini"
                  style="width: 160px"
                  disabled
                  placeholder="请选择"
                  v-model="form.payType"
                >
                  <el-option label="全款" :value="1"></el-option>
                  <el-option label="按揭" :value="2"></el-option>
                </el-select>
              </el-form-item>
              <!-- <el-form-item class="form_item"
                            label="首付金额"
                            v-if="form.payType === 2">
                <el-input size="mini"
                          disabled
                          style="width: 160px;"
                          placeholder="请输入"
                          v-model="form.paymentFirst"></el-input>
              </el-form-item>
              <el-form-item class="form_item"
                            label="按揭金额"
                            v-if="form.payType === 2">
                <el-input size="mini"
                          style="width: 160px;"
                          disabled
                          placeholder="请输入"
                          v-model="form.mortgagePayment"></el-input>
              </el-form-item>
              <el-form-item class="form_item"
                            v-if="form.payType === 2"
                            label="按揭期数">
                <el-select size="mini"
                           disabled
                           style="width:160px;"
                           placeholder="请选择"
                           v-model="form.paymentYears">
                  <el-option v-for="item in orderLoadDurationDics"
                             :key="item.dataValue"
                             :label="item.dataDisplay"
                             :value="item.dataValue"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="form_item"
                            label="成交金额"
                            prop="paymentDeal">
                <el-input size="mini"
                          disabled
                          style="width: 160px;"
                          placeholder="请输入"
                          v-model="form.paymentDeal"></el-input>
              </el-form-item>
              <el-form-item class="form_item"
                            label="其他费用">
                <el-input size="mini"
                          disabled
                          style="width: 160px;"
                          placeholder="请输入"
                          v-model="form.paymentOther"></el-input>
              </el-form-item>
              <el-form-item class="form_item"
                            label="车辆用途"
                            prop="vehiclePurpose">
                <el-select size="mini"
                           disabled
                           style="width:160px;"
                           placeholder="请选择"
                           v-model="form.vehiclePurpose">
                  <el-option v-for="item in orderVehiclePurposeDics"
                             :key="item.dataValue"
                             :label="item.dataDisplay"
                             :value="item.dataValue"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="form_item"
                            label="是否置换"
                            prop="isReplace">
                <el-select size="mini"
                           disabled
                           style="width:160px;"
                           placeholder="请选择"
                           v-model="form.isReplace">
                  <el-option :value="true"
                             label="是"></el-option>
                  <el-option :value="false"
                             label="否"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="form_item"
                            label="置换车牌号"
                            v-if="form.isReplace">
                <el-input size="mini"
                          disabled
                          style="width: 160px;"
                          placeholder="请输入"
                          v-model="form.replacedCarNum"></el-input>
              </el-form-item>
              <el-form-item class="form_item"
                            label="是否二级店销售">
                <el-select size="mini"
                           disabled
                           style="width:160px;"
                           placeholder="请选择"
                           v-model="form.isSaledBySecond">
                  <el-option :value="true"
                             label="是"></el-option>
                  <el-option :value="false"
                             label="否"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="form_item"
                            label="二级店名称"
                            v-if="form.isSaledBySecond">
                <el-select size="mini"
                           disabled
                           style="width:160px;"
                           placeholder="请选择"
                           v-model="form.secondDealerName">
                  <el-option v-for="item in secondDealers"
                             :key="item"
                             :label="item"
                             :value="item"></el-option>
                </el-select>
              </el-form-item> -->
              <el-form-item class="form_item" label="预计交车时间">
                <el-date-picker
                  size="mini"
                  disabled
                  style="width: 160px"
                  v-model="form.deliverDate"
                  :clearable="false"
                  type="date"
                  value-format="timestamp"
                  placeholder="选择日期"
                ></el-date-picker>
              </el-form-item>
              <el-form-item class="form_item" label="购车类型" prop="businessType">
                <el-select
                  size="mini"
                  disabled
                  style="width: 160px"
                  placeholder="请选择"
                  v-model="form.businessType"
                >
                  <el-option
                    v-for="item in businessTypeOptions"
                    :key="item.dataValue"
                    :label="item.dataDisplay"
                    :value="item.dataValue"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-row>
            <el-row style="margin-top: 10px">
              <div class="title">客户信息</div>
            </el-row>
            <el-row style="background: #fff; padding: 15px 0">
              <el-form-item class="form_item" label="类型" prop="customerType">
                <el-select
                  size="mini"
                  disabled
                  style="width: 160px"
                  placeholder="请选择"
                  v-model="form.customerType"
                >
                  <el-option label="个人" :value="1"></el-option>
                  <el-option label="企业" :value="2"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                class="form_item"
                :label="form.customerType === 1 ? '订车人姓名' : '公司名称'"
                prop="customerName"
              >
                <el-input
                  size="mini"
                  disabled
                  style="width: 160px"
                  placeholder="请输入"
                  v-model.trim="form.customerName"
                  onkeydown="if (event.keyCode===13 || event.keyCode===32){return false;}"
                >
                </el-input>
              </el-form-item>
              <el-form-item
                class="form_item"
                label="联系电话"
                prop="customerPhone"
              >
                <el-input
                  size="mini"
                  disabled
                  style="width: 160px"
                  placeholder="请输入"
                  v-model="form.customerPhone"
                >
                </el-input>
              </el-form-item>
              <el-form-item
                class="form_item"
                label="证件类型"
                prop="identifyType"
              >
                <el-select
                  size="mini"
                  disabled
                  style="width: 160px"
                  placeholder="请选择"
                  v-model="form.identifyType"
                >
                  <el-option
                    v-for="item in orderIdentifyTypeDics"
                    :key="item.dataValue"
                    :label="item.dataDisplay"
                    :value="item.dataValue"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                class="form_item"
                label="证件号码"
                prop="identifyNo"
              >
                <el-input
                  size="mini"
                  disabled
                  style="width: 160px"
                  placeholder="请输入"
                  v-model="form.identifyNo"
                >
                </el-input>
              </el-form-item>
              <el-form-item
                class="form_item"
                label="推荐人姓名"
                prop="referrerName"
              >
                <el-input
                  size="mini"
                  disabled
                  style="width: 160px"
                  placeholder="请输入"
                  v-model="form.referrerName"
                ></el-input>
              </el-form-item>
              <el-form-item
                class="form_item"
                label="推荐人电话"
                prop="referrerPhone"
              >
                <el-input
                  size="mini"
                  disabled
                  style="width: 160px"
                  placeholder="请输入"
                  v-model="form.referrerPhone"
                ></el-input>
              </el-form-item>
              <el-form-item class="form_item" label="省/市/区">
                <el-select
                  size="mini"
                  disabled
                  style="width: 100px"
                  placeholder="选择省"
                  clearable
                  @change="provinceChange"
                  v-model="form.customerProvince"
                >
                  <el-option
                    v-for="item in provinces"
                    :key="item"
                    :label="item"
                    :value="item"
                  ></el-option>
                </el-select>
                <el-select
                  size="mini"
                  style="width: 100px"
                  disabled
                  placeholder="选择市"
                  clearable
                  @change="cityChange"
                  v-model="form.customerCity"
                >
                  <el-option
                    v-for="item in citys"
                    :key="item"
                    :label="item"
                    :value="item"
                  ></el-option>
                </el-select>
                <el-select
                  size="mini"
                  style="width: 100px"
                  disabled
                  placeholder="选择区"
                  clearable
                  v-model="form.customerCounty"
                >
                  <el-option
                    v-for="item in countys"
                    :key="item"
                    :label="item"
                    :value="item"
                  ></el-option>
                </el-select>
                <!-- <el-cascader :props="adressProps"
                             v-model="form.address"
                             size="mini"
                             v-if="show"
                             disabled
                             placeholder="请选择"
                             style="width:200px;"></el-cascader> -->
              </el-form-item>
              <el-form-item
                class="form_item"
                label="详细地址"
                prop="customerAddress"
              >
                <el-input
                  size="mini"
                  disabled
                  style="width: 300px"
                  placeholder="请输入"
                  v-model="form.customerAddress"
                >
                </el-input>
              </el-form-item>
            </el-row>
            <el-row style="margin-top: 10px">
              <div class="title">其他信息</div>
              <el-row style="background: #fff; padding: 15px 0">
                <!-- <el-form-item class="form_item"
                              label="转他店交付">   
                  <el-select size="mini"
                             disabled
                             style="width:160px;"
                             placeholder="请选择"
                             v-model="form.isOtherDealer">
                    <el-option :value="true"
                               label="是"></el-option>
                    <el-option :value="false"
                               label="否"></el-option>
                  </el-select>
                </el-form-item> -->
                <!-- <el-form-item class="form_item"
                              label="锐见报表统计">
                  <el-select size="mini"
                             disabled
                             style="width:160px;"
                             placeholder="请选择"
                             v-model="form.isReport">
                    <el-option :value="true"
                               label="是"></el-option>
                    <el-option :value="false"
                               label="否"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item class="form_item"
                              label="下次跟进时间"
                              prop="nextFollowDate">
                  <el-date-picker size="mini"
                                  disabled
                                  style="width:160px;"
                                  v-model="form.nextFollowDate"
                                  :clearable="false"
                                  type="date"
                                  value-format="timestamp"
                                  placeholder="选择日期"></el-date-picker>
                </el-form-item> -->
                <el-form-item class="form_item" label="成交渠道">
                  <el-input v-if="form.reactivateSource" size="mini" style="width: 160px;" v-model="form.reactivateSource" disabled></el-input>
                  <el-input v-else size="mini" style="width: 160px;" v-model="form.sourceName" disabled></el-input>
                </el-form-item>
                <el-form-item class="form_item" label="备注">
                  <el-input
                    type="textarea"
                    disabled
                    style="width: 330px"
                    :rows="2"
                    placeholder="请输入备注内容"
                    v-model="form.remark"
                  ></el-input>
                </el-form-item>
              </el-row>
              <el-row style="background: #fff; padding: 15px 0">
                <el-col :span="12">
                  <el-form-item
                    class="form_item"
                    label="订车合同/协议(最多三张)"
                    prop="images1"
                  >
                    <Upload ref="upload1" v-model="form.images1" disabled></Upload>
                    <!-- <el-upload
                      action
                      accept=".jpeg,.jpg,.png"
                      :limit="3"
                      disabled
                      :multiple="true"
                      :file-list="fileList1"
                      class="hide"
                      list-type="picture-card"
                    >
                      <i slot="default" class="el-icon-plus"></i>
                      <div slot="file" slot-scope="{ file }">
                        <img
                          class="el-upload-list__item-thumbnail"
                          :src="file.url"
                          alt=""
                        />
                        <span class="el-upload-list__item-actions">
                          <span
                            class="el-upload-list__item-preview"
                            @click="handlePictureCardPreview1(file)"
                          >
                            <i class="el-icon-zoom-in"></i>
                          </span>
                        </span>
                      </div>
                      <div
                        slot="tip"
                        v-if="fileList1.length > 0"
                        class="el-upload__tip"
                      >
                        支持JPG、JPEG、PNG格式
                      </div>
                    </el-upload> -->
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item class="form_item" label="交易凭证">
                    <Upload ref="upload2" v-model="form.images2" disabled></Upload>
                    <!-- <el-upload
                      action
                      accept=".jpeg,.jpg,.png"
                      :limit="3"
                      ref="upload2"
                      :multiple="true"
                      disabled
                      :file-list="fileList2"
                      class="hide"
                      list-type="picture-card"
                    >
                      <i slot="default" class="el-icon-plus"></i>
                      <div slot="file" slot-scope="{ file }">
                        <img
                          class="el-upload-list__item-thumbnail"
                          :src="file.url"
                          alt=""
                        />
                        <span class="el-upload-list__item-actions">
                          <span
                            class="el-upload-list__item-preview"
                            @click="handlePictureCardPreview2(file)"
                          >
                            <i class="el-icon-zoom-in"></i>
                          </span>
                        </span>
                      </div>
                      <div
                        slot="tip"
                        v-if="fileList2.length > 0"
                        class="el-upload__tip"
                      >
                        支持JPG、JPEG、PNG格式
                      </div>
                    </el-upload> -->
                  </el-form-item>
                </el-col>
              </el-row>
            </el-row>
          </el-form>
        </el-col>
        <el-col :span="7" style="margin-left: 20px">
          <div class="title">订单操作记录</div>
          <el-row style="min-height: 196px; background: #fff">
            <el-timeline style="margin-top: 15px; margin-left: 30px">
              <el-timeline-item
                v-for="(item, index) in timelines"
                :key="index"
                color="#0bbd87"
                :timestamp="parseTime(item.createdAt, '{y}/{m}/{d} {h}:{i}')"
              >
                <div class="boxLine">
                  <div class="title">{{ item.orderStatus | orderStatus }}</div>
                  <span v-html="item.content.replaceAll('\n', '<br/>')"></span>
                </div>
              </el-timeline-item>
            </el-timeline>
          </el-row>
        </el-col>
      </el-row>
    </div>
    <el-dialog
      title="驳回订单"
      :visible.sync="orderCancelLog"
      width="600px"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
    >
      <el-form
        ref="orderCancelForm"
        :rules="orderCancelRules"
        label-position="right"
        :model="orderCancelForm"
        label-width="100px"
      >
        <el-row>
          <el-form-item
            class="form_item_val"
            :label="item.label"
            v-for="(item, index) in orderBackReasonTags"
            :key="index"
          >
            <el-tag
              v-for="radio in item.radios"
              :key="radio"
              :type="
                orderCancelForm['content' + (index + 1)] === radio
                  ? 'danger'
                  : 'info'
              "
              @click="tagSelect2(radio, index)"
            >
              {{ radio }}</el-tag
            >
          </el-form-item>
          <el-form-item
            class="form_item_val"
            label="驳回原因"
            :prop="
              orderCancelForm.content1 === '' &&
              orderCancelForm.content2 === '' &&
              orderCancelForm.content3 === '' &&
              orderCancelForm.content4 === '' &&
              orderCancelForm.content5 === ''
                ? 'remark'
                : ''
            "
          >
            <el-input
              type="textarea"
              :rows="4"
              placeholder="请输入订单驳回的原因"
              v-model="orderCancelForm.remark"
            ></el-input>
          </el-form-item>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="orderCancelLog = false" type="text">取消</el-button>
        <el-button
          @click="orderCanceConfim"
          type="text"
          :loading="confirmLoading"
          >确定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      title="同意审核"
      :visible.sync="orderThroughLog"
      width="500px"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
    >
      <el-form
        ref="orderThroughForm"
        label-position="right"
        :model="orderThroughForm"
        label-width="100px"
      >
        <!-- <el-row>
          <el-form-item class="form_item_val"
                        label="是否同步销服">
            <el-radio-group v-model="orderThroughForm.isSyncSiebel">
              <el-radio :label="true"
                        size="mini">是</el-radio>
              <el-radio :label="false"
                        size="mini">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-row> -->
        <el-row>
          <el-form-item class="form_item_val" label="备注">
            <el-input
              type="textarea"
              :rows="4"
              placeholder="请输入"
              v-model="orderThroughForm.remark"
            ></el-input>
          </el-form-item>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="orderThroughLog = false" type="text">取消</el-button>
        <el-button
          @click="orderThroughConfim"
          type="text"
          :loading="confirmLoading"
          >确定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      :visible.sync="withCarLog"
      @close="toCustomer"
      :close-on-click-modal="false"
      width="20%"
      title="是否配车"
    >
      <div class="submit-fo">
        <el-button @click="toCar" size="mini">立即配车</el-button>
        <el-button
          style="margin-left: 25px !important"
          @click="inform"
          size="mini"
          >授权客户经理配车</el-button
        >
      </div>
      <div class="ps" @click="toCustomer">暂不配车</div>
    </el-dialog>
    <el-image-viewer
      v-if="showViewer"
      :on-close="closeViewer"
      :url-list="fileList"
      :initialIndex="initialIndex"
    />
  </div>
</template>

<script>
import ElImageViewer from "./image-viewer";
import { remarkValidator } from '@/assets/js/util'
import { modelOptionalsKeyMap, orderStatusDics } from './constants.js'
import Upload from "@/components/common/Upload.vue";
import locked from '../../assets/img/locked.svg'
import unlocked from '../../assets/img/unlocked.svg'
var order_vm;
export default {
  components: { ElImageViewer, Upload },
  data() {
    order_vm = this;
    return {
      locked,
      unlocked,
      modelOptionalsKeyMap,
      dealer: this.$common.getLoginInfo().profile,
      orderId: Number(this.$route.query.id),
      formName: sessionStorage.getItem("form"),
      type: this.$route.query.type,
      allowOrderVerify: this.$common.getLoginInfo().allowOrderVerify,
      active: 1,
      dialogVisible: false,
      dialogImageUrl: "",
      initialIndex: 0,
      fileList: [],
      fileList1: [],
      fileList2: [],
      form: {
        otdStatus: "",
        // contractNo: '',
        orderType: "",
        modelId: [],
        modelColor: "",
        // modelVin: '',
        // isSanbao: true,
        paymentDown: "",
        payType: 2,
        // paymentFirst: '',
        // paymentYears: '',
        // paymentDeal: '',
        // paymentOther: '',
        // vehiclePurpose: '',
        // isReplace: false,
        // replacedCarNum: '',
        // isSaledBySecond: false,
        // secondDealerName: '',
        customerType: 1,
        customerName: "",
        customerPhone: "",
        identifyType: 1,
        identifyNo: "",
        identifyNos: "",
        customerAddress: "",
        // address: [],
        deliverDate: "",
        // isReport: true,
        nextFollowDate: "",
        remark: "",
        // mortgagePayment: '',
        customerProvince: "",
        customerCity: "",
        customerCounty: "",
        extOrderId: "",
        carInternalColor: "",
        carModelOptionals: {
          optional1: "",
          optional2: "",
          optional3: "",
          optional4: "",
          optional5: "",
          optional6: "",
          optional7: "",
          optional8: "",
          optional9: "",
        }, // 车型选装
        businessType: '', // 购车类型
      },
      formRules: {
        contractNo: [
          {
            required: true,
            message: "请输入合同编号",
            trigger: "blur"
          }
        ],
        orderType: [
          {
            required: true,
            message: "请选择订单类型",
            trigger: "blur"
          }
        ],
        modelId: [
          {
            required: true,
            message: "请选择订购车型",
            trigger: "blur"
          }
        ],
        modelColor: [
          {
            required: true,
            message: "请选择外观颜色",
            trigger: "blur"
          }
        ],
        isSanbao: [
          {
            required: true,
            message: "请选择是否三包车",
            trigger: "blur"
          }
        ],
        paymentDown: [
          {
            required: true,
            message: "请输入订金",
            trigger: "blur"
          }
        ],
        payType: [
          {
            required: true,
            message: "请选择付款方式",
            trigger: "blur"
          }
        ],
        paymentDeal: [
          {
            required: true,
            message: "请输入成交金额",
            trigger: "blur"
          }
        ],
        vehiclePurpose: [
          {
            required: true,
            message: "请选择车辆用途",
            trigger: "blur"
          }
        ],
        isReplace: [
          {
            required: true,
            message: "请选择是否置换",
            trigger: "blur"
          }
        ],
        customerType: [
          {
            required: true,
            message: "请选择客户类型",
            trigger: "blur"
          }
        ],
        customerName: [
          {
            required: true,
            message: "请输入订车人姓名",
            trigger: "blur"
          }
        ],
        identifyType: [
          {
            required: true,
            message: "请选择证件类型",
            trigger: "blur"
          }
        ],
        identifyNo: [
          {
            required: true,
            message: "请输入证件号码",
            trigger: "blur"
          }
        ],
        customerPhone: [
          {
            required: true,
            message: "请输入联系电话",
            trigger: "blur"
          }
        ],
        deliverDate: [
          {
            required: true,
            message: "请选择预计交车时间",
            trigger: "blur"
          }
        ],
        nextFollowDate: [
          {
            required: true,
            message: "请选择下次跟进时间",
            trigger: "blur"
          }
        ],
        businessType: [
          {
            required: true,
            message: "请选择购车类型",
            trigger: "blur"
          }
        ]
      },
      orderTypeDics: [], // 订单类型
      orderLoadDurationDics: [], // 按揭期数
      orderVehiclePurposeDics: [], // 车辆用途
      orderIdentifyTypeDics: [], // 证件类型
      businessTypeOptions: [], // 购车类型
      orderStatusDics, // 操作记录标题
      carOptions: [], // 订购车型
      colors: [], //车辆颜色
      vins: [], // 车架号
      orderCancelLog: false, // 驳回弹框
      timelines: [],
      disabled: true,
      orderCancelForm: {
        remark: "",
        content1: "",
        content2: "",
        content3: "",
        content4: "",
        content5: ""
      },
      orderCancelRules: {
        remark: [
          {
            required: true,
            validator: (...args) => {
              remarkValidator("订单驳回的原因", ...args)
            },
            trigger: "blur"
          }
        ]
      },
      confirmLoading: false,
      orderThroughLog: false, // 同意审核弹框
      orderThroughForm: {
        isSyncSiebel: true,
        remark: ""
      },
      withCarLog: false, //是否配车弹框
      secondDealers: [],
      adressProps: {
        // 省市区信息
        lazy: true,
        lazyLoad(node, resolve) {
          if (node.level === 0) {
            order_vm.$httpAuth
              .post("/v2/appCustomerService/orderRegion", {
                dealerId: order_vm.dealer.dealerId,
                province: "",
                city: ""
              })
              .then(function (res) {
                const provinces = res.data.data.map((value) => ({
                  value: value,
                  label: value,
                  leaf: node.level >= 2
                }));
                resolve(provinces);
              })
              .catch((err) => {
                console.log(err);
              });
          }
          if (node.level === 1) {
            order_vm.$httpAuth
              .post("/v2/appCustomerService/orderRegion", {
                dealerId: order_vm.dealer.dealerId,
                province: node.value,
                city: ""
              })
              .then(function (res) {
                const cities = res.data.data.map((value) => ({
                  value: value,
                  label: value,
                  leaf: node.level >= 2
                }));
                resolve(cities);
              })
              .catch((err) => {
                console.log(err);
              });
          }
          if (node.level === 2) {
            order_vm.$httpAuth
              .post("/v2/appCustomerService/orderRegion", {
                dealerId: order_vm.dealer.dealerId,
                province: node.parent.value,
                city: node.value
              })
              .then(function (res) {
                const countys = res.data.data.map((value) => ({
                  value: value,
                  label: value,
                  leaf: node.level >= 2
                }));
                resolve(countys);
              })
              .catch((err) => {
                console.log(err);
              });
          }
        }
      },
      show: false,
      provinces: [],
      citys: [],
      countys: [],
      showViewer: false,
      orderBackReasonTags: [],
      carInternalColor: [],
      carModelOptionalsMaps: {},
      customerOrder: {}
    };
  },
  computed: {
    isEditing() {
      return this.disabled === false
    },
    carModelOptionalsComputed() {
      let value = {}
      for (const key in this.carModelOptionalsMaps) {
        if(Object.prototype.hasOwnProperty.call(this.carModelOptionalsMaps, key) && this.carModelOptionalsMaps[key] && this.carModelOptionalsMaps[key].some(Boolean)) {
          value[key] = this.carModelOptionalsMaps[key]
          if(this.isEditing && !this.form.carModelOptionals[key]) {
            this.form.carModelOptionals[key] = (value[key][0] === '无选装' ? '' : value[key][0])
          }
        }
      }
      return value
    }
  },
  created() {
    var baseInfo = this.$common.getBaseInfo();
    this.orderTypeDics = baseInfo.orderTypeDics;
    this.orderLoadDurationDics = baseInfo.orderLoadDurationDics;
    this.orderVehiclePurposeDics = baseInfo.orderVehiclePurposeDics;
    this.orderIdentifyTypeDics = baseInfo.orderIdentifyTypeDics;
    this.businessTypeOptions = baseInfo.businessTypes;
    var orderBackReasonTags = baseInfo.orderBackReasonTags;
    this.orderBackReasonTags = orderBackReasonTags.map((item) => {
      return {
        label: item.split(":")[0],
        radios: item.split(":")[1].split("/")
      };
    });
    this.retrieveCarOptions();
    this.getOrder();
    this.getSecondDealers();
    this.getProvinces();
  },
  mounted() {},
  methods: {
    // 返回
    back() {
      if (sessionStorage.getItem("form") === "customerDetail") {
        this.$router.push({
          path: "/customer/detail/" + this.form.customerId
        });
      } else if (sessionStorage.getItem("form") === "order") {
        this.$router.push({
          path: "/order/zzOrder"
        });
      } else {
        this.$router.go(-1);
      }
    },
    tagSelect2(radio, index) {
      if (this.orderCancelForm["content" + (index + 1)] != radio) {
        this.orderCancelForm["content" + (index + 1)] = radio;
      } else {
        this.orderCancelForm["content" + (index + 1)] = "";
      }
    },
    closeViewer() {
      this.showViewer = false;
    },
    // 省改变
    provinceChange(val, isClear = true) {
      this.$httpAuth
        .post("/v2/appCustomerService/orderRegion", {
          dealerId: this.dealer.dealerId,
          province: val,
          city: ""
        })
        .then((res) => {
          this.citys = res.data.data;
          if(isClear) {
            this.form.customerCity = "";
            this.form.customerCounty = "";
          }
        });
    },
    // 市改变
    cityChange(val, isClear = true) {
      this.$httpAuth
        .post("/v2/appCustomerService/orderRegion", {
          dealerId: this.dealer.dealerId,
          province: this.form.customerProvince,
          city: val
        })
        .then((res) => {
          this.countys = res.data.data;
          if(isClear) {
            this.form.customerCounty = "";
          }
        });
    },
    // 获取省
    getProvinces() {
      this.$httpAuth
        .post("/v2/appCustomerService/orderRegion", {
          dealerId: this.dealer.dealerId,
          province: "",
          city: ""
        })
        .then((res) => {
          this.provinces = res.data.data;
        });
    },
    //点击预览
    handlePictureCardPreview1(file) {
      this.fileList = this.fileList1.map((item) => item.url);
      const reg = /^https:\/\/.*$/
      this.initialIndex = this.fileList1.findIndex(item => {
        if(reg.test(file.url)) {
          return item.url == file.url
        } else {
          return item.url == file.response
        }
      })
      this.showViewer = true;
    },
    //点击预览
    handlePictureCardPreview2(file) {
      this.fileList = this.fileList2.map((item) => item.url);
      const reg = /^https:\/\/.*$/
      this.initialIndex = this.fileList2.findIndex(item => {
        if(reg.test(file.url)) {
          return item.url == file.url
        } else {
          return item.url == file.response
        }
      })
      this.showViewer = true;
    },
    parseTime(time, cFormat) {
      if (arguments.length === 0) {
        return null;
      }
      const format = cFormat || "{y}-{m}-{d} {h}:{i}:{s}";
      let date;
      if (typeof time === "object") {
        date = time;
      } else {
        if (("" + time).length === 10) time = parseInt(time) * 1000;
        date = new Date(time);
      }
      const formatObj = {
        y: date.getFullYear(),
        m: date.getMonth() + 1,
        d: date.getDate(),
        h: date.getHours(),
        i: date.getMinutes(),
        s: date.getSeconds(),
        a: date.getDay()
      };
      const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
        let value = formatObj[key];
        if (key === "a")
          return ["一", "二", "三", "四", "五", "六", "日"][value - 1];
        if (result.length > 0 && value < 10) {
          value = "0" + value;
        }
        return value || 0;
      });
      return time_str;
    },
    retrieveCarOptions() {
      var parent = this;
      this.$httpAuth
        .post("/v1/dealerRpc/vehicleJsonTree", {
          dealerId: this.dealer.dealerId
        })
        .then(function (response) {
          parent.carOptions = response.data.data;
        });
    },
    changeSpecColor(val) {
      var modelId = val[1];
      this.form.modelColor = "";
      this.colors = [];
      this.form.carInternalColor = ''
      // 选装重置
      Object.keys(this.form.carModelOptionals).forEach(key => {
        this.form.carModelOptionals[key] = "";
      });
      this.carModelOptionalsMaps = {}
      var that = this;
      this.$httpAuth
        .post("/v2/appCustomerService/vehicleColor", {
          modelId: parseInt(modelId),
          dealerId: this.dealer.dealerId
        })
        .then(function (response) {
          that.colors = response.data.data;
        })
        .catch(() => {});
    },
    getVins() {
      var that = this;
      this.$httpAuth
        .post("/v2/appCustomerService/vehiclesByColor", {
          modelId: parseInt(this.form.modelId[0]),
          dealerId: this.dealer.dealerId,
          color: this.form.modelColor
        })
        .then(function (response) {
          that.vins = response.data.data;
        })
        .catch(() => {});
    },
    modelColorChange() {
      this.getVins()
      this.form.carInternalColor = ''
      this.getCarModelDetail();
      // 选装重置
      Object.keys(this.form.carModelOptionals).forEach(key => {
        this.form.carModelOptionals[key] = "";
      });
      this.carModelOptionalsMaps = {}
    },
    carInternalColorChange() {
      // 选装重置
      Object.keys(this.form.carModelOptionals).forEach(key => {
        this.form.carModelOptionals[key] = "";
      });
      this.carModelOptionalsMaps = {}
      this.getCarModelOptionals()
    },
    // 获取订单详情
    getOrder() {
      var that = this;
      this.$httpAuth
        .post("/v2/appCustomerService/orderDetail", {
          orderId: this.orderId,
          dealerId: this.dealer.dealerId
        })
        .then(function (res) {
          let data = res.data;
          that.customerOrder = data.order
          that.timelines = data.timelines;
          const { carInternalColor = '', carColor, choicePackage1Name, choicePackage2Name,
            choicePackage3Name, choicePackage4Name, choicePackage5Name, choicePackage6Name, choicePackage7Name, 
            choicePackage8Name, choicePackage9Name
           } = data.carInfo || {}
          that.form = {
            referrerName: data.order.referrerName || "无",
            referrerPhone: data.order.referrerPhone || "无",
            otdStatus: data.order.otdStatus,
            customerId: data.order.customerId,
            extOrderId: data.order.extOrderId,
            // contractNo: data.order.contractNo,
            orderType: data.order.orderType || "",
            modelId: [],
            modelColor: carColor || that.data.order.modelColor,
            carInternalColor,
            carModelOptionals: {
              optional1: choicePackage1Name,
              optional2: choicePackage2Name,
              optional3: choicePackage3Name,
              optional4: choicePackage4Name,
              optional5: choicePackage5Name,
              optional6: choicePackage6Name,
              optional7: choicePackage7Name,
              optional8: choicePackage8Name,
              optional9: choicePackage9Name,
            }, // 车型选装
            // modelVin: data.order.modelVin,
            // isSanbao: data.order.isSanbao,
            paymentDown: data.order.paymentDown,
            payType: data.order.payType,
            // paymentFirst: data.order.paymentFirst,
            // paymentYears: data.order.paymentYears,
            // paymentDeal: data.order.paymentDeal,
            // paymentOther: data.order.paymentOther,
            // mortgagePayment: data.order.mortgagePayment,
            // vehiclePurpose: data.order.vehiclePurpose,
            // isReplace: data.order.isReplace,
            customerType: data.order.customerType,
            customerName:
              data.order.customerType === 1
                ? data.order.customerName
                : data.order.companyName,
            customerPhone: data.order.customerPhone,
            identifyType: data.order.identifyType,
            identifyNo: data.order.identifyNo,
            identifyNos: data.order.identifyNo,
            customerAddress: data.order.customerAddress,
            deliverDate: data.order.deliverDate ? data.order.deliverDate * 1000 : '',
            // isReport: data.order.isReport,
            remark: data.order.remark,
            // isOtherDealer: data.order.isOtherDealer,
            // replacedCarNum: data.order.replacedCarNum,
            // isSaledBySecond: data.order.isSaledBySecond,
            // secondDealerName: data.order.secondDealerName,
            nextFollowDate: "",
            customerProvince: data.order.customerProvince,
            customerCity: data.order.customerCity,
            customerCounty: data.order.customerCounty,
            images1: [],
            images2: [],
            reactivateSource: data.reactivateSource || '',
            sourceName: data.sourceName || '',
            businessType: data.order.businessType || '',
          };
          that.provinceChange(data.order.customerProvince, false);
          that.cityChange(data.order.customerCity, false);
          setTimeout(() => {
            that.form.customerCity = data.order.customerCity;
            that.form.customerCounty = data.order.customerCounty;
          }, 300);
          // that.fileList1 = [];
          // that.fileList2 = [];
          if (data.order.images1 != "") {
            that.form.images1 = data.order.images1.split(",")
          }
          if (data.order.images2 != "") {
            that.form.images2 = data.order.images2.split(",")
          }
          that.show = true;
          that.getmodelId(data.order.modelId);
        })
        .catch((e) => {});
    },
    getCarModelOptionals() {
      this.$httpAuth
        .post("/v2/appVerifyService/getCarModelOptionals", {
          dealerId: this.dealer.dealerId,
          modelId: Number(this.form.modelId[1]),
          carExternalColor: this.form.modelColor,
          carInternalColor: this.form.carInternalColor
        })
        .then((res) => {
          this.carModelOptionalsMaps = res.data;
        });
    },
    formatReferrerName(str = "") {
      return (
        str.replace(
          /^(.{1})(.*)$/,
          (match, p1, p2) => p1 + p2.replace(/./g, "*")
        ) || "--"
      );
    },
    formatReferrerPhone(str = "") {
      return (
        str.replace(
          /^(.{3})(.*)(.{4})$/,
          (match, p1, p2, p3) => p1 + p2.replace(/./g, "*") + p3
        ) || "--"
      );
    },
    getmodelId(id) {
      var that = this;
      this.$httpAuth
        .post("/v1/baseRpc/getSpec", {
          id: id
        })
        .then(function (res) {
          that.form.modelId = [
            res.data.spec.seriesId + "",
            res.data.spec.id + ""
          ];
          that.getCarModelDetail();
          that.getCarModelOptionals()
          that.form.colors = res.data.spec.colors.split(",");
        })
        .catch(() => {});
    },
    getCarModelDetail() {
      this.$httpAuth
        .post("/v2/appVerifyService/getCarModelDetail", {
          dealerId: this.dealer.dealerId,
          modelId: Number(this.form.modelId[1]),
          carExternalColor: this.form.modelColor,
          carWheelBoss: "",
          carWheel: "",
          carInternalColor: this.form.carInternalColor
        })
        .then((res) => {
          this.carInternalColor = res.data.carInternalColor;
          if(this.isEditing && this.carInternalColor && this.carInternalColor[0]) {
            this.form.carInternalColor = this.carInternalColor[0]
            this.getCarModelOptionals()
          }
          const isHasInternalColor = this.carInternalColor.some(Boolean)
          if(!isHasInternalColor) {
            this.getCarModelOptionals()
          }
        });
    },
    // 驳回确定
    orderCanceConfim() {
      this.$refs["orderCancelForm"].validate((valid) => {
        if (valid) {
          var that = this;
          that.confirmLoading = true;
          let params = {
            dealerId: this.dealer.dealerId,
            orderId: this.orderId,
            remark: this.orderCancelForm.remark
          };
          if (this.orderCancelForm.content1 != "") {
            params["content1"] =
              this.orderBackReasonTags[0].label +
              ":" +
              this.orderCancelForm.content1;
          }
          if (this.orderCancelForm.content2 != "") {
            params["content2"] =
              this.orderBackReasonTags[1].label +
              ":" +
              this.orderCancelForm.content2;
          }
          if (this.orderCancelForm.content3 != "") {
            params["content3"] =
              this.orderBackReasonTags[2].label +
              ":" +
              this.orderCancelForm.content3;
          }
          if (this.orderCancelForm.content4 != "") {
            params["content4"] =
              this.orderBackReasonTags[3].label +
              ":" +
              this.orderCancelForm.content4;
          }
          if (this.orderCancelForm.content5 != "") {
            params["content5"] =
              this.orderBackReasonTags[4].label +
              ":" +
              this.orderCancelForm.content5;
          }
          this.$httpAuth
            .post("/v2/appVerifyService/rejectOrder", params)
            .then(function (res) {
              if (res.data.success) {
                that.$httpAuth
                  .post("/v2/appCustomerService/orderDetail", {
                    orderId: that.orderId,
                    dealerId: that.dealer.dealerId
                  })
                  .then((res2) => {
                    if (res2.data.order.status === 3) {
                      that.$router.push({
                        path: "/approved",
                        query: { id: that.orderId }
                      });
                    } else {
                      that.$router.push({
                        path: "/rejected",
                        query: { id: that.orderId }
                      });
                    }
                  });
                that.$message({
                  type: "success",
                  message: "驳回订单成功"
                });
                that.confirmLoading = false;
                that.orderCancelLog = false;
              }
            })
            .catch(() => {
              that.confirmLoading = false;
            });
        }
      });
    },
    // 去客户详情
    toCustomer() {
      if (this.type) {
        sessionStorage.setItem("type", 1);
        this.$router.push({
          path: "/customer/detail/" + this.form.customerId
        });
      } else {
        this.$router.push({
          path: "/customer/detail/" + this.form.customerId
        });
      }
    },
    // 驳回
    reject() {
      this.orderCancelForm = {
        remark: "",
        content1: "",
        content2: "",
        content3: "",
        content4: "",
        content5: ""
      };
      this.orderCancelLog = true;
    },
    // 同意
    through() {
      this.orderThroughForm = {
        isSyncSiebel: true,
        remark: ""
      };
      this.orderThroughLog = true;
    },
    // 同意确认
    orderThroughConfim() {
      this.confirmLoading = true;
      var that = this;
      this.$httpAuth
        .post("/v2/appVerifyService/confirmOrder", {
          dealerId: this.dealer.dealerId,
          orderId: this.orderId,
          isSyncSiebel: this.orderThroughForm.isSyncSiebel,
          remark: this.orderThroughForm.remark
        })
        .then(function (res) {
          if (res.data.success) {
            that.confirmLoading = false;
            that.orderCancelLog = false;
            that.orderThroughLog = false;
            if (that.type) {
              that.$router.push({
                path: "/approved",
                query: { id: that.orderId, type: that.type }
              });
            } else {
              that.$router.push({
                path: "/approved",
                query: { id: that.orderId }
              });
            }
          }
        })
        .catch(() => {
          that.confirmLoading = false;
        });
    },
    // 立即配车
    toCar() {
      this.$router.push({
        path: "/approved",
        query: { id: this.orderId }
      });
    },
    // 授权客户经理配车
    inform() {
      var that = this;
      this.$httpAuth
        .post("/v2/appVerifyService/informOrderVehicle", {
          dealerId: this.dealer.dealerId,
          orderId: this.orderId
        })
        .then(function (res) {
          if (res.data.success) {
            that.withCarLog = false;
            that.$message({
              type: "success",
              message: "授权成功"
            });
            that.toCustomer();
          }
        })
        .catch(() => {
          that.withCarLog = false;
        });
    },
    // 客户经理进入时的订单撤回
    orderWithdraw() {
      this.$confirm("是否确定撤回该订单?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          var that = this;
          this.$httpAuth
            .post("/v2/appCustomerService/cancelOrder", {
              dealerId: this.dealer.dealerId,
              orderId: this.orderId,
              reason: "1"
            })
            .then(function (res) {
              if (res.data.success) {
                that.$message({
                  type: "success",
                  message: "撤回订单成功"
                });
                that.$router.push({
                  path: "/waitingSubmit",
                  query: { id: that.orderId }
                });
              }
            })
            .catch(() => {});
        })
        .catch(() => {});
    },
    // 获取二级店
    getSecondDealers() {
      var that = this;
      this.$httpAuth
        .post("/v2/appCustomerService/orderSecondDealers", {
          dealerId: this.dealer.dealerId
        })
        .then(function (res) {
          that.secondDealers = res.data.data;
        })
        .catch(() => {});
    }
  },
  watch: {},
  filters: {
    orderStatus(val) {
      for (var i = 0; i < order_vm.orderStatusDics.length; i++) {
        var o = order_vm.orderStatusDics[i];
        if (o.orderStatus == val) {
          return o.name;
        }
      }
      return "";
    }
  }
};
</script>
<style scoped>
.back {
  font-size: 14px;
}

.el-step__title {
  font-size: 14px;
}

.mt2 {
  margin-top: 20px;
}

.mt1 {
  margin-top: 10px;
}

.title {
  width: 100%;
  font-size: 14px;
  font-weight: 700;
  color: rgba(10, 18, 32, 0.64);
  letter-spacing: normal;
  margin-bottom: 15px;
  margin-top: 10px;
}

.form_item {
  margin-bottom: 15px !important;
}

.tips {
  width: 100%;
  text-align: center;
  font-weight: 600;
  margin-bottom: 20px;
}

.submit-fo {
  display: flex;
  justify-content: center;
  margin-bottom: 10px;
}

.ps {
  width: 100%;
  text-align: center;
  height: 50px;
  font-size: 12px;
  line-height: 40px;
  cursor: pointer;
}

.boxLine {
  width: 250px;
  padding: 5px 0 5px 10px;
  border: 1px solid #e8ebed;
  font-size: 12px;
}

.boxLine .title {
  font-weight: 600;
  color: #000;
}

.el-timeline-item__wrapper {
  position: relative;
}

.el-timeline-item__timestamp {
  position: absolute;
  left: -110px;
  top: 0;
}

.toCustomer {
  color: rgb(64, 158, 255);
  cursor: pointer;
  margin-left: 10px;
  font-weight: 400;
}

.hide .el-upload--picture-card {
  display: none;
}

.el-upload-list__item {
  width: 90px !important;
  height: 90px !important;
}

.el-upload {
  width: 90px !important;
  height: 90px !important;
  line-height: 90px !important;
}

.el-tag + .el-tag {
  margin-left: 10px;
}
</style>
